import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-mb-confirm-dialog',
  templateUrl: './mb-confirm-dialog.component.html',
  styleUrls: ['./mb-confirm-dialog.component.scss'],
  standalone: false
})
export class MbConfirmDialogComponent {
  @Input() title = 'Confirmar acción';
  @Input() message = '¿Deseas continuar?';
  @Input() confirmText = 'Confirmar';
  @Input() cancelText = 'Cancelar';

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  public onBackdropClick(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('overlay')) {
      this.cancelled.emit();
    }
  }
}
